<script lang="ts">
    import {_, locale} from 'svelte-i18n'
    import {DefinedMessageType, Role} from './types';
    import Kitchen from '@smui/snackbar/kitchen';
    import Header from './Header.svelte';
    import {
        activeOperators,
        application,
        contextService,
        conversations,
        mySession,
        paths,
        popupService,
        showableLocales,
        userService
    } from './services';
    import ClientLoginForm from './ClientLoginForm.svelte';
    import OperatorLoginForm from './OperatorLoginForm.svelte';
    import {onMount} from 'svelte';
    import ConversationEndDialog from './ConversationEndDialog.svelte';
    import UserEditDialog from './UserEditDialog.svelte';
    import DefinedMessage from './DefinedMessage.svelte';
    import {LocalizationService} from './service/localization-service';

    export let showFooter: boolean = true;

    let showOperatorLoginForm: boolean = false;

    let kitchen;
    let conversationEndDialog;
    let userPasswordEditDialog;
    let userEditDialog;
    let userCreateDialog;
    onMount(() => {
        popupService.registerAddHandler(kitchen);
        conversations.registerConversationEndDialog(conversationEndDialog);
        userService.registerUserPasswordEditDialog(userPasswordEditDialog);
        userService.registerUserEditDialog(userEditDialog);
        userService.registerUserCreateDialog(userCreateDialog);
    });

</script>

<svelte:head>
    <title>{$_('meta.title')}</title>

    <meta name="description" content="{$_('meta.description')}">
    <meta name="keywords" content="{$_('meta.keywords')}">

    {#if contextService.getTheme() !== 'default'}
        <link rel="stylesheet" href="/build/smui-{contextService.getTheme()}.css" />
    {/if}

</svelte:head>

<Kitchen bind:this={kitchen} dismiss$class="material-icons" />

<div class="app-container mdc-typography">
    <Header />

    <main style="height: 100%; overflow: auto;">
        {#if $mySession.roles.includes(Role.ANONYMOUS)}

            <div style="margin: 36px 50px 20px 50px;">
                <div style="margin: 30px 0; padding: 10px 0">
                    <h1 class="mdc-typography--headline2" style="font-size: 3.6em; margin-top: 8px; margin-bottom: 0px;">{$_('commons.homepage.Title')}</h1>
                    <h2 class="mdc-typography--headline3" style="font-size: 1.3em; margin-top: 6px; line-height: 2rem;">{$_('commons.homepage.Subtitle')}</h2>
                    {#if showOperatorLoginForm}
                        <OperatorLoginForm />
                    {:else if $activeOperators.length > 0}
                        <ClientLoginForm/>
                        <div class="mdc-typography--body2" style="margin: 10px 0; padding: 10px 0">
                            <DefinedMessage type={DefinedMessageType.HOME_INFO} />
                        </div>
                    {:else}
                        <div class="mdc-typography--body2" style="margin: 10px 0; padding: 10px 0">
                            <DefinedMessage type={DefinedMessageType.HOME_INFO_NO_OPERATOR} />
                        </div>
                    {/if}
                </div>
            </div>

            <div style="margin: 20px 30px;">
                <a href="https://strada.cz/" target="_blank" class="footer-logo-link footer-logo-link-strada">
                    <img src="logo/logo-lastrada.png" style="width: 50px" alt="logo LaStrada" />
                </a>
                <a href="https://www.linkaduveryuo.cz" target="_blank" class="footer-logo-link footer-logo-link-lduo">
                    <img src="logo/logo-lduo.png" style="width: 100px" alt="logo Linka důvěry Ústí nad Orlicí" />
                </a>
                <a href="https://www.csspraha.cz/prazska-linka-duvery" target="_blank" class="footer-logo-link footer-logo-link-pld">
                    <img src="logo/logo-pld.png" style="width: 160px" alt="logo linka duvery" />
                </a>
                <a href="https://www.csspraha.cz" target="_blank" class="footer-logo-link footer-logo-link-csspraha">
                    <img src="logo/logo-csspraha.png" style="width: 160px" alt="logo csspraha" />
                </a>
                <a href="https://www.praha.eu" target="_blank" class="footer-logo-link footer-logo-link-praha">
                    <img src="logo/logo-praha.png" style="width: 68px" alt="logo praha" />
                </a>
            </div>

            {#if $mySession.roles.includes(Role.ANONYMOUS)}
                <div style="margin: 20px 50px;">
                    <a href={$paths.noOp} on:click={() => showOperatorLoginForm = !showOperatorLoginForm}>
                        {#if showOperatorLoginForm}
                            {$_('user.auth.ClientLogin')}
                        {:else}
                            {$_('user.auth.EmployeeLogin')}
                        {/if}
                    </a>
                </div>
            {/if}

        {:else}
            <slot />
        {/if}
    </main>

    {#if showFooter}
        <footer style="padding: 8px; font-size: 0.8em">
            <div>
                <span style="display: none">{$_('commons.Version')} {application.version}, {$_('commons.Backend')} {application.backendUrl}</span>

                {#if $mySession.roles.includes(Role.ADMIN)}
                    | <a href={$paths.settings}>{$_('commons.Settings')}</a>
                    | <a href={$paths.sessionLog}>{$_('user.session.SessionLog')}</a>
                {/if}

                {#each $showableLocales as loc}
                    {#if loc !== $locale}
                        | <a href={$paths.localeChange(loc)}>{LocalizationService.getLanguageText(loc)}</a>{' '}
                    {/if}
                {/each}
            </div>
        </footer>
    {/if}
</div>

<ConversationEndDialog bind:this={conversationEndDialog} />

<UserEditDialog bind:this={userPasswordEditDialog} usernameEdit={false} passwordEdit={true} passwordRequired={true} currentPasswordRequired={true} operatorRoleEdit={false} intervisorRoleEdit={false} />
<UserEditDialog bind:this={userEditDialog} usernameEdit={true} passwordEdit={true} passwordRequired={false} currentPasswordRequired={false} operatorRoleEdit={true} intervisorRoleEdit={true} />
<UserEditDialog bind:this={userCreateDialog} usernameEdit={true} passwordEdit={true} passwordRequired={true} currentPasswordRequired={false} operatorRoleEdit={true} intervisorRoleEdit={true} />

<style lang="scss">
  .app-container {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
  }

  .footer-logo-link {
    margin: 0 10px;
  }
</style>